@if (viewAlertOptions().show) {
  <ncp-alert [(options)]="viewAlertOptions">
    <alert-body class="d-inline-flex flex-grow-1 flex-row">
      <div class="d-flex align-self-baseline flex-grow-1 align-items-baseline justify-content-between">
        <span class="badge bg-danger p-2 ms-1 my-0">
          <h6 class="my-0">{{alertText}}</h6>
        </span>
<!--        <span class="flex-grow-1"></span>-->
        <div class="">
          <ncp-button #printBtn [options]="printBtnOptions()" />
          <ncp-button #cdaBtn [options]="cdaBtnOptions()" />
        </div>
<!--        <ncp-button-->
<!--          class="btn badge btn-danger p-2 ms-1 my-0 border-0"-->
<!--          type="button"-->
<!--          (click)="print()"-->
<!--        >-->
<!--          <h6 class="my-0">print</h6>-->
<!--        </ncp-button>-->
      </div>
    </alert-body>
  </ncp-alert>

  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <div #documentPreview class="d-flex flex-grow-1">
      @if (previewType() === 'application/pdf' && previewUrl()) {
        <div class="d-flex flex-grow-1">
          <embed
            [src]="previewUrl()"
            type="application/pdf"
            class="flex-grow-1"
          />
        </div>
      }

      @if (previewType() === 'text/html' && previewUrl()) {
        <div class="d-flex flex-grow-1">
          <iframe
            [src]="previewUrl()"
            class="flex-grow-1"
            style="border: var(--border-2) var(--border-solid) var(--border-primary-blue); border-radius: 4px;"
          ></iframe>
        </div>
      }
    </div>
  </ncp-modal>
}
